<template>
    <v-dialog v-model="shows" max-width="480" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="isLoaded" height="100%">
            <v-card-title>
                <template v-if="isCreate">교육 카테고리 생성</template>
                <template v-else>교육 카테고리 상세</template>
                <v-spacer />
                <v-btn absolute right text icon @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text class="py-5" style="max-height:calc(90vh - 16px - 32px - 10px - 1px - 1px - 60px); overflow-y:auto">
                <v-text-field label="카테고리명" v-model="inputs.name" v-bind="attrs_input" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="px-6 grey lighten-5">
                <!-- <v-switch v-model="inputs.isOnRecommendation" inset label="추천사용" class="ma-0 pa-0" hide-details /> -->
                <v-spacer />
                <v-btn large color="primary" @click="save">
                    저장하기
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { attrs_input } from "@/assets/variables";

const initProgramCategory = () => ({
    name: null,
    isOnRecommendation: true,
});

export default {
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        isLoaded: false,

        inputs: {},

        attrs_input,
        isMobile: detect == "mobile",
    }),
    computed: {
        _category() {
            return this.value?._id;
        },
        isCreate() {
            return !this._category;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        "inputs.area.width"() {
            const { width = 0, height = 0 } = this.inputs.area;
            this.inputs.area.square = width * height || 0;
        },
        "inputs.area.height"() {
            const { width = 0, height = 0 } = this.inputs.area;
            this.inputs.area.square = width * height || 0;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            try {
                if (this.isCreate) {
                    this.inputs = { ...initProgramCategory() };
                } else {
                    const { category } = await api.console.programCategories.get({ _id: this._category });
                    this.inputs = category;
                }
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.isLoaded = true;
            }
        },

        validate() {},

        async save() {
            try {
                this.validate();

                // Document POST / PUT
                let category;
                if (this.isCreate) category = (await api.console.programCategories.post(this.inputs))?.category;
                else category = (await api.console.programCategories.put(this.inputs))?.category;

                // Files POST / PUT

                alert("저장되었습니다");
                if (this.isCreate) this.$emit("created");
                else this.$emit("input", category);
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>
